import { State } from 'src/redux';

export const getResources = (state: State) => state.resources.resources;
